import { toast } from 'sonner';

export async function copyTextToClipboard(text: string, label?: string): Promise<void> {
  if (!text) return;
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label ? `Copied ${label}` : 'Copied to clipboard');
  } catch {
    toast.error('Failed to copy');
  }
}
